// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var AdminUserStatus = function (x) {
    return x;
};
var tsBridgeAdminUserStatus = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("AdminUserStatus")("__brandAdminUserStatus"));
    }
};
var writeAdminUserStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showAdminUserStatus = Data_Show.showString;
var readAdminUserStatus = Simple_JSON.readString;
var ordAdminUserStatus = Data_Ord.ordString;
var newtypeAdminUserStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeAdminUserStatus = AdminUserStatus;
var eqAdminUserStatus = Data_Eq.eqString;
export {
    AdminUserStatus,
    makeAdminUserStatus,
    unwrap,
    newtypeAdminUserStatus,
    eqAdminUserStatus,
    ordAdminUserStatus,
    showAdminUserStatus,
    readAdminUserStatus,
    writeAdminUserStatus,
    tsBridgeAdminUserStatus
};
//# sourceMappingURL=index.js.map
